<template>
    <el-input
        v-if="mode === 'edit'"
        v-model="currentValue"
        :type="type"
        :autosize="{ minRows: 2, maxRows: 10 }"
        resize="none"
        :readonly="readonly"
        :placeholder="placeholder"
        :data-bot="dataBot"
        :size="size"
    >
    </el-input>
    <p v-else>
        {{ currentValue }}
    </p>
</template>

<script>
export default {
    props: {
        mode: {
            type: String,
            default: '',
        },
        readonly: {
            type: Boolean,
            required: false,
            default: false,
        },
        modelValue: {
            type: [Number, String, Boolean],
            required: false,
            default: '',
        },
        type: {
            type: String,
            required: false,
            default: 'text',
        },
        placeholder: {
            type: String,
            required: false,
            default: '',
        },
        dataBot: {
            type: String,
            required: false,
            default: '',
        },
        size: {
            type: String,
            default: 'default',
        },
    },
    data() {
        return {
            currentValue:
                this.modelValue === null ? '' : this.modelValue.replace(/<br\s*[\/]?>/gi, '\n'),
        };
    },
    watch: {
        currentValue() {
            this.$emit('update:modelValue', this.currentValue);
        },
        value(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.currentValue = newValue;
            }
        },
    },
};
</script>
